function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export var SessionSideThumbnailInfoUtils = /*#__PURE__*/ function() {
    "use strict";
    function SessionSideThumbnailInfoUtils(adBreakTimeAdapter) {
        _class_call_check(this, SessionSideThumbnailInfoUtils);
        _define_property(this, "adBreakTimeAdapter", void 0);
        this.adBreakTimeAdapter = adBreakTimeAdapter;
    }
    _create_class(SessionSideThumbnailInfoUtils, [
        {
            key: "adaptThumbnailPositionsToContentTime",
            value: function adaptThumbnailPositionsToContentTime(thumbnailRenderInfo) {
                var _this = this;
                if (this.adBreakTimeAdapter && thumbnailRenderInfo !== null) {
                    return {
                        previousTiles: thumbnailRenderInfo.previousTiles.map(function(tile) {
                            return _object_spread_props(_object_spread({}, tile), {
                                startPosition: _this.adBreakTimeAdapter.timeIncludingAdsToContentTime(tile.startPosition)
                            });
                        }),
                        currentThumbnail: _object_spread_props(_object_spread({}, thumbnailRenderInfo.currentThumbnail), {
                            startPosition: this.adBreakTimeAdapter.timeIncludingAdsToContentTime(thumbnailRenderInfo.currentThumbnail.startPosition)
                        }),
                        nextTiles: thumbnailRenderInfo.nextTiles.map(function(tile) {
                            return _object_spread_props(_object_spread({}, tile), {
                                startPosition: _this.adBreakTimeAdapter.timeIncludingAdsToContentTime(tile.startPosition)
                            });
                        })
                    };
                } else {
                    return thumbnailRenderInfo;
                }
            }
        }
    ]);
    return SessionSideThumbnailInfoUtils;
}();

//# sourceMappingURL=session-side-thumbnail-info-utils.js.map